import { useVerifyAdmin } from 'helper';
import { useVerifyCompanyAdmin } from 'helper';
import { useVerifyInstaller } from 'helper';
import HGBreadcrumbs from 'components/HGBreadcrumbs';
import { Card } from 'components/shadcn/ui/card';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from 'components/shadcn/ui/tooltip';

function TopNav() {
    const isAdmin = useVerifyAdmin();
    const isCompanyAdmin = useVerifyCompanyAdmin();
    const isInstaller = useVerifyInstaller();

    return (
        <Card className="z-40 flex h-16 items-center justify-between rounded-2xl px-4 backdrop-blur">
            <HGBreadcrumbs />
            <div className="flex items-center gap-2">
                <TooltipProvider>
                    {isAdmin && (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <span className="rounded bg-info px-2 py-1 text-xs font-medium text-background">
                                    Admin
                                </span>
                            </TooltipTrigger>
                            <TooltipContent>
                                This is a super admin account. You can view and
                                edit customers, devices, and installers.
                            </TooltipContent>
                        </Tooltip>
                    )}
                    {isCompanyAdmin && !isAdmin && (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <span className="rounded bg-info px-2 py-1 text-xs font-medium text-background">
                                    Company Admin
                                </span>
                            </TooltipTrigger>
                            <TooltipContent>
                                This is a company admin account.
                            </TooltipContent>
                        </Tooltip>
                    )}
                    {isInstaller && !isCompanyAdmin && !isAdmin && (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <span className="rounded bg-info px-2 py-1 text-xs font-medium text-background">
                                    Installer
                                </span>
                            </TooltipTrigger>
                            <TooltipContent>
                                This is an installer account.
                            </TooltipContent>
                        </Tooltip>
                    )}
                </TooltipProvider>
            </div>
        </Card>
    );
}

export default TopNav;
